import React from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { getGeocode } from 'use-places-autocomplete';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import { setMapLocation } from '@src/core/controllers/map/redux';
import { trackError } from '@src/core/sentry';
import { ArcIconButton, ArcStack, ArcTooltip } from '@src/core/ui';
import { FindMeProps } from './types';

const FindMe: React.FC<FindMeProps> = () => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(false);

  const getPosition = (options?: PositionOptions): Promise<GeolocationPosition> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation is not supported'));
        return;
      }
      navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
  };

  const findMe = async () => {
    setLoading(true);
    try {
      const position = await getPosition();
      const { latitude: lat, longitude: lng } = position.coords;
      const addresses = await getGeocode({ location: { lat, lng } });
      dispatch(setMapLocation({ 
        latitude: lat, 
        longitude: lng, 
        address: addresses[0]?.formatted_address,
      }));
    } catch (error: unknown) {
      trackError(error instanceof Error ? error : new Error(String(error)), {
        code: 'FE_0011',
      });
      if (error instanceof Error) {
        toast.error(error.message);
        return;
      }
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ArcStack 
      width={50} 
      height={50} 
      borderRadius={2}
      alignItems='center' 
      justifyContent='center' 
      bgcolor='background.paper'>

      <ArcTooltip title='Find me'>
        <ArcIconButton isLoading={isLoading} onClick={findMe}>
          <MyLocationIcon />
        </ArcIconButton>
      </ArcTooltip>

    </ArcStack>
  );
};

export default FindMe;